module.exports = __webpack_public_path__ + "img/icon-company.8458a390.svg";